import React, { useEffect, useState } from 'react';
import memberAPI from '../../middleware/memberAPI';
import { alertError, parseMemberQRCode } from '../../Util/Util';
import { Button, CircularProgress, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { find, map, orderBy, trim, filter } from 'lodash';
import Barcode from 'react-barcode';
import { Alert, AlertTitle } from '@material-ui/lab';
import Swal from 'sweetalert2';
import PaperLinkScanner from '../../components/Bonus/PaperLinkScanner';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
    padding: theme.spacing(2),
  },
  upgrade: {
    fontSize: '1.8rem',
    fontWeight: '600',
    margin: theme.spacing(3, 'auto'),
    maxWidth: '360px',
  },
  memberInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '1rem',
    fontWeight: '600',
    padding: theme.spacing(1),
  },
  payingHistoryList: {
    fontSize: '0.9rem',
    fontWeight: '600',
    listStyle: 'none',
    padding: '0',
    overflowY: 'auto',
    maxHeight: '130px',
  },
  payingHistory: {
    margin: theme.spacing(1),
  },
  card: {
    marginTop: theme.spacing(2),
  },
  memberPlans: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'stretch',
    gap: '36px',
  },
  memberPlan: {
    width: '100px',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  upgradeBtns: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-around',
    alignItems: 'stretch',
    gap: '60px',
    margin: '24px 0',
  },
  upgradeBtn: {
    height: '60px',
  },
  alert: {
    textAlign: 'left',
  },
  block: {
    margin: theme.spacing(1, 0),
    textAlign: 'center',
  },
  stepBtns: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'space-evenly',
    margin: theme.spacing(2, 0, 0),
  },
  redTitle: {
    fontSize: '1.2rem',
    fontWeight: '600',
    margin: '16px',
    color: '#ff4e23',
  },
  memberInfoFail: {
    color: '#ff4e23',
  },
  barcodeWrap: {
    '& > svg, & svg': {
      maxWidth: '100%',
      height: 'auto',
      display: 'block',
    },
  },
}));

const UpgradePayingMember = (props) => {
  const { qrcode } = props;
  const classes = useStyles();
  const { currentStore } = useSelector((state) => state.loginState);
  const [pageStep, setPageStep] = useState('init');
  const [isLoading, setIsLoading] = useState(false);
  const [userInfo, setUserInfo] = useState();
  const [userPayingList, setUserPayingList] = useState();
  const [isPayingMember, setIsPayingMember] = useState(false);
  const [lastExpirationDate, setLastExpirationDate] = useState();
  const [payingMemberPlans, setPayingMemberPlans] = useState();
  const [selectPlan, setSelectPlan] = useState();
  const [consignmentCode, setConsignmentCode] = useState();
  const [isConsignment, setIsConsignment] = useState(false);
  const [isConsignmentCodeFail, setIsConsignmentCodeFail] = useState(false);
  const [claimType, setClaimType] = useState();
  const [upgradeUserPayingMemberId, setUpgradeUserPayingMemberId] = useState();
  const [claimSuccessMessage, setClaimSuccessMessage] = useState();

  useEffect(() => {
    if (currentStore && currentStore.id) {
      memberAPI.getAllPayingMemberPlans(currentStore.id).then(
        (rs) => {
          setPayingMemberPlans(rs);
        },
        (error) => {
          alertError(error);
        },
      );
    }
  }, [currentStore]);

  useEffect(() => {
    if (qrcode) {
      setIsLoading(true);

      const memberQRCode = parseMemberQRCode(qrcode);

      memberAPI
        .checkPayingMember(memberQRCode.member)
        .then(
          (response) => {
            if (response.userInfo) {
              setUserInfo(response.userInfo);
              setUserPayingList(response.payingHistoryList);
              setIsPayingMember(response.isPayingMember === true);

              const sortedPayingList = orderBy(
                response.payingHistoryList,
                ['endAt'],
                ['desc'],
              );

              if (sortedPayingList.length > 0) {
                setLastExpirationDate(
                  sortedPayingList[0].endAt.substring(0, 10),
                );
              }
            }
          },
          (error) => {
            alertError(error);
            setPageStep('fail');
          },
        )
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [qrcode]);

  useEffect(() => {
    if (payingMemberPlans && qrcode) {
      const memberQRCode = parseMemberQRCode(qrcode);
      const qrcodeSelectPlan = memberQRCode.subMode
        ? memberQRCode.subMode
        : memberQRCode.selectValue;
      const qrcodeConsignmentCode = memberQRCode.subMode
        ? memberQRCode.selectValue
        : undefined;

      if (qrcodeSelectPlan) {
        const userSelectPlan = find(
          payingMemberPlans,
          (payingMemberPlan) =>
            parseInt(payingMemberPlan.id, 10) ===
            parseInt(qrcodeSelectPlan, 10),
        );

        if (userSelectPlan) {
          setSelectPlan(userSelectPlan);
        } else {
          Swal.fire({
            title: '所選 VIP 會員方案無法使用',
            text: '請確認後台和會員所選分店是否一致',
            icon: 'error',
          });
        }
      }

      if (trim(qrcodeConsignmentCode) !== '') {
        setConsignmentCode(qrcodeConsignmentCode);
      }
    }
  }, [payingMemberPlans, qrcode]);

  useEffect(() => {
    if (pageStep === 'init' && !!userInfo && !!payingMemberPlans) {
      setPageStep('upgrade');
    }
  }, [userInfo, payingMemberPlans, pageStep]);

  useEffect(() => {
    if (trim(consignmentCode) !== '') {
      memberAPI.getMember(consignmentCode).then(
        (rs) => {},
        (error) => {
          setIsConsignmentCodeFail(true);
        },
      );
    }
  }, [consignmentCode]);

  useEffect(() => {
    if (claimType === 'digital') {
      Swal.fire({
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: '發送',
        cancelButtonText: '取消',
        title: '確認發送電子券嗎？',
      }).then((rs) => {
        if (rs.value) {
          claimDigital();
        } else {
          setClaimType(undefined);
        }
      });
    }
  }, [claimType]);

  const upgradePayingMember = (payingMemberPlanId) => {
    setIsLoading(true);

    memberAPI
      .upgradePayingMember(
        userInfo.id,
        payingMemberPlanId,
        trim(consignmentCode) !== '' && isConsignmentCodeFail === false
          ? consignmentCode
          : undefined,
      )
      .then(
        (response) => {
          setPageStep('success');
          setUpgradeUserPayingMemberId(response.userPayingMemberId);
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const handleSelectPlan = (payingMemberPlan) => {
    setSelectPlan(payingMemberPlan);
  };

  const handleCancleSelectPlan = () => {
    setSelectPlan(undefined);
  };

  const handleChangeIsConsignment = (checked) => {
    setIsConsignment(checked);
  };

  const claimDigital = () => {
    setIsLoading(true);

    memberAPI
      .claimDigitalCoupon(upgradeUserPayingMemberId)
      .then(
        (rs) => {
          Swal.fire({
            title: '領券完成',
            icon: 'success',
          });
          setClaimSuccessMessage('電子券領取完成');
        },
        (error) => {
          alertError(error);
          setClaimType(undefined);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className={classes.root}>
      {pageStep === 'init' && (
        <div>
          <CircularProgress />
          <div>讀取中</div>
        </div>
      )}

      {pageStep === 'upgrade' && (
        <div className={classes.upgrade}>
          {userInfo && (
            <div>
              <div>會員資訊</div>
              <div className={classes.memberInfo}>
                <div className={classes.memberInfoTitle}>姓名</div>
                <div>{userInfo.realName}</div>
              </div>
              <div className={classes.memberInfo}>
                <div className={classes.memberInfoTitle}>電話</div>
                <div>{userInfo.cellPhone}</div>
              </div>
              <div className={classes.memberInfo}>
                <div className={classes.memberInfoTitle}>電子郵件</div>
                <div>{userInfo.email}</div>
              </div>
              <div className={classes.memberInfo}>
                <div className={classes.memberInfoTitle}>會員狀態</div>
                <div>{isPayingMember ? 'VIP會員' : '一般會員'}</div>
              </div>
              {isPayingMember && (
                <div className={classes.memberInfo}>
                  <div className={classes.memberInfoTitle}>到期日</div>
                  <div>{lastExpirationDate}</div>
                </div>
              )}
              <div className={classes.memberInfo}>
                <div className={classes.memberInfoTitle}>推薦碼</div>
                <div
                  className={
                    isConsignmentCodeFail ? classes.memberInfoFail : ''
                  }>
                  {consignmentCode}
                  {isConsignmentCodeFail ? ' | 無效推薦碼' : ''}
                </div>
              </div>

              <div>
                <div className={classes.title}>
                  {isPayingMember ? '續約VIP會員' : '升級VIP會員'}
                </div>

                {!selectPlan && (
                  <div className={classes.memberPlans}>
                    {map(
                      payingMemberPlans,
                      (payingMemberPlan, payingMemberPlanKey) => {
                        return (
                          <Button
                            key={payingMemberPlanKey}
                            className={classes.memberPlan}
                            variant="contained"
                            color="primary"
                            size="large"
                            fullWidth
                            onClick={() => handleSelectPlan(payingMemberPlan)}
                            disabled={isLoading}>
                            {payingMemberPlan.name +
                              ' $' +
                              payingMemberPlan.price}
                          </Button>
                        );
                      },
                    )}
                  </div>
                )}

                {selectPlan && (
                  <div>
                    <div className={classes.barcodeWrap}>
                      <Barcode
                        height={100}
                        fontSize={16}
                        value={selectPlan.barcode}
                        width={3}
                      />
                    </div>

                    <div style={{ marginBottom: '12px' }}>
                      {selectPlan.name + ' $' + selectPlan.price}
                    </div>

                    <Alert
                      severity="error"
                      style={{
                        textAlign: 'left',
                        backgroundColor: '#000',
                        color: '#fff',
                      }}>
                      請務必在POS機上結帳後，才能按『
                      {isPayingMember ? ' 續約 ' : ' 升級 '}』幫會員升級
                    </Alert>

                    <div className={classes.upgradeBtns}>
                      <Button
                        className={classes.upgradeBtn}
                        variant="contained"
                        color="primary"
                        size="large"
                        fullWidth
                        disabled={isLoading}
                        onClick={() => upgradePayingMember(selectPlan.id)}>
                        {isPayingMember ? '續約' : '升級'}
                      </Button>

                      <Button
                        className={classes.upgradeBtn}
                        variant="contained"
                        color="default"
                        size="large"
                        fullWidth
                        disabled={isLoading}
                        onClick={handleCancleSelectPlan}>
                        重選
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {userPayingList && userPayingList.length > 0 && (
            <div className={classes.card}>
              <div>付費紀錄</div>
              <ul className={classes.payingHistoryList}>
                {userPayingList.map((item, index) => (
                  <li key={index} className={classes.payingHistory}>
                    {item.payingType + ' '}
                    {moment(item.startAt).format('YYYY-MM-DD')} 到{' '}
                    {moment(item.endAt).format('YYYY-MM-DD')}
                    <div style={{ color: '#999' }}>
                      付款時間{' '}
                      {moment(item.payingTime).format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {pageStep === 'success' && (
        <div className={classes.alert}>
          <Alert severity="success">
            <AlertTitle>{isPayingMember ? '續約成功' : '升級成功'}</AlertTitle>
            會員帳號已享有VIP會員權利，請會員重新整理頁面即可顯示最新VIP會員記錄.
          </Alert>

          {selectPlan && selectPlan.packageInfo && !claimType && (
            <div>
              <div className={classes.block}>
                <div className={classes.redTitle}>
                  請選擇套券領取方式(只能擇一)
                </div>

                <Divider />

                <div className={classes.stepBtns}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setClaimType('digital')}
                    disabled={isLoading}
                    size="large">
                    領電子券
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setClaimType('paper')}
                    disabled={isLoading}
                    size="large">
                    領紙本券
                  </Button>
                </div>
              </div>
            </div>
          )}

          {claimType === 'paper' && (
            <div className={classes.block}>
              <div className={classes.redTitle}>
                如需紙本歸戶，請選擇下面掃描
              </div>

              <Button
                variant="contained"
                color="default"
                size="small"
                onClick={() => {
                  setClaimType(undefined);
                }}>
                返回選擇
              </Button>

              <Divider />

              <PaperLinkScanner
                userId={userInfo.id}
                productPackageId={
                  selectPlan && selectPlan.packageInfo
                    ? selectPlan.packageInfo.id
                    : undefined
                }
                isConsignment={isConsignment}
                onIsConsignmentChange={handleChangeIsConsignment}
                userPayingMemberId={upgradeUserPayingMemberId}
                isLoading={isLoading}
                onLoadingChange={setIsLoading}
              />
            </div>
          )}

          {claimSuccessMessage && (
            <div className={classes.card}>
              <Alert severity="info">{claimSuccessMessage}</Alert>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UpgradePayingMember;
